import {Head} from '@unhead/react';
import PropTypes from 'prop-types';

const Helm = ({title, children}) => (
  <>
    <Head titleTemplate="%s ・ Planet Insights Platform">
      <title>{title}</title>
    </Head>
    {children}
  </>
);

Helm.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
};

export default Helm;
